export default {
  gift_card_removed: 'Lahjakortti poistettu',
  invalid_gift_card: 'Lahjakortti ei kelpaa',
  gift_card_applied: 'Lahjakortti käytössä',
};
